import type { TApplicationDocumentHistoryItem } from '~/modules/covenants/types.ts';
import { DOCUMENT_GENERATION_HISTORY_LABELS } from '~/modules/covenants/CovenantsDataApplicationForm/components/documentGenerationHistory/constants.ts';

const isSameHistoryPeriod = (
  first: TApplicationDocumentHistoryItem,
  second: TApplicationDocumentHistoryItem
) =>
  first.yearPeriod === second.yearPeriod &&
  first.childPeriod === second.childPeriod &&
  first.deadline === second.deadline;

export const getHistoryVersionLabel = (
  items: TApplicationDocumentHistoryItem[],
  index: number
): string => {
  const item = items[index];

  if (!item) {
    return '';
  }

  const matchingItems = items.filter((candidate) => isSameHistoryPeriod(candidate, item));

  if (matchingItems.length < 2) {
    return '';
  }

  const version = matchingItems.findIndex((candidate) => candidate.id === item.id) + 1;
  return `${DOCUMENT_GENERATION_HISTORY_LABELS.versionPrefix} ${version}`;
};

export const getHistoryItemDetails = (
  item: TApplicationDocumentHistoryItem,
  versionLabel: string
): string =>
  [
    item.yearPeriod,
    item.childPeriod,
    item.deadline ? `${DOCUMENT_GENERATION_HISTORY_LABELS.deadlinePrefix} ${item.deadline}` : '',
    versionLabel,
  ]
    .filter(Boolean)
    .join(' · ');
